// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"36393dde","488":"2bbdc5ec"}[chunkId] + ".chunk.js";
};